import { useMediaQuery } from '@epilot/concorde-elements'

export const useSystemDarkMode = (): boolean => {
  return useMediaQuery('(prefers-color-scheme: dark)')
}
